import {lazyRegister} from '@/Core/lazyRegister';
import {BaseApiFactory} from '@/Factories/BaseApiFactory';
import {OrderStatisticsDailyItem} from "@/models";

export class OrderStatisticService {
    static $inject = ['BaseApiFactory'];

    constructor(private baseApiFactory: BaseApiFactory) {
    }

    getDaily(query: {
        periodType: string,
        fromDate?: string,
        toDate?: string,
        distributorId?: number
    }, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<OrderStatisticsDailyItem[]>('/v2/api/order-statistic/daily', query, cancelToken);
    }

    getByType(query: {
        groupType: string,
        periodType: string,
        fromDate?: string,
        toDate?: string,
        distributorId?: number
    }, cancelToken?: AbortSignal) {
        return this.baseApiFactory.getData<OrderStatisticsDailyItem[]>('/v2/api/order-statistic/by-type', query, cancelToken);
    }

    getByCountry(groupType: string, periodType: string, fromDate?: string, toDate?: string, countryId?: number, cancelToken?: AbortSignal) {
        return this.baseApiFactory
            .getData<OrderStatisticsDailyItem[]>('/v2/api/order-statistic/by-country/by-type', {
                groupType,
                periodType,
                fromDate,
                toDate,
                countryId
            }, cancelToken);
    }

    getByCountryDaily(periodType: string, fromDate?: string, toDate?: string, countryId?: number, cancelToken?: AbortSignal) {
        return this.baseApiFactory
            .getData<OrderStatisticsDailyItem[]>('/v2/api/order-statistic/by-country/daily', {
                periodType,
                fromDate,
                toDate,
                countryId
            }, cancelToken);
    }
}

lazyRegister.service('OrderStatisticService', OrderStatisticService);
